export default function blog_sorting() {
    const sortBtn = document.querySelector('.sort_btn');
    const sortList = document.querySelector('.sort_list');
    const sortItems = document.querySelectorAll('.sort_list li');


    if (!sortBtn || !sortList || !sortItems.length) {
      return;
    }

    const sortText = sortBtn.querySelector('span');

    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortList.classList.toggle('active');
    });

    sortItems.forEach(item => {
      item.addEventListener('click', function () {
        sortText.textContent = this.textContent;
        sortList.classList.remove('active');
      });
    });

    document.addEventListener('click', function () {
      sortList.classList.remove('active');
    });
}
